import { Icon } from '@purpur/library/icon';
import styled, { css } from 'styled-components';

import { TextInput } from '@telialt/common-text-input/src';
import { getPurpurColor } from '@telialt/common-theme/src/purpurSelectors';

import { InputVariant } from '../../model';

export const SearchInput = styled(TextInput)`
    input[type='search']::-webkit-search-decoration,
    input[type='search']::-webkit-search-cancel-button,
    input[type='search']::-webkit-search-results-button,
    input[type='search']::-webkit-search-results-decoration {
        -webkit-appearance: none;
    }
`;

export const InputBackdrop = styled.div`
    background: ${getPurpurColor('functionalBlack')};
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    transition: opacity 0.3s ease-in-out;
    opacity: 0;
    pointer-events: none;
`;

export const InputContainer = styled.div`
    position: relative;
    z-index: 20;
`;

export const CustomSearchIcon = styled(Icon)`
    color: ${getPurpurColor('textWeak')};
`;

type InputProps = {
    $variant?: InputVariant;
    $isSuggestionsVisible?: boolean;
};

export const InputWrapper = styled.div<InputProps>`
    position: relative;

    ${(props) =>
        props.$variant === 'gray' &&
        css`
            [class*='_purpur-text-field-default__input'] {
                background-color: ${getPurpurColor('gray50')};
                height: 4rem;
            }

            [class*='_purpur-text-field-default__frame'] {
                border: none;
                outline: 0 !important;
            }

            &:not(:last-child) [class*='_purpur-text-field-default__input-container'] {
                border-radius: ${props.$isSuggestionsVisible ? '0.5rem 0.5rem 0 0' : '0.5rem'};
                border-color: transparent;
            }
            &:last-child [class*='_purpur-text-field-default__input-container'] {
                border-radius: 0.5rem;
                border-color: transparent;
            }

            ${CustomSearchIcon} {
                color: ${getPurpurColor('functionalBlack')};
            }

            &:focus-within ${CustomSearchIcon} {
                color: ${getPurpurColor('purple500')};
            }

            ${InputBackdrop} {
                opacity: ${props.$isSuggestionsVisible ? '0.24' : '0'};
            }
        `};
`;
